/**
 * @deprecated This helper is deprecated. Use the @dealroadshow/uikit-date-time class with appropriate methods instead.
 */
const getUTCDate = (date: Date = new Date()): Date => new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000));

export default getUTCDate;
